import { useDispatch } from 'react-redux';
import { addToast } from '~features/toast/ducks';

const useQRCodeReader = ({ onRead, onError }) => {
  const dispatch = useDispatch();

  if (!onError)
    // eslint-disable-next-line no-param-reassign
    onError = message =>
      dispatch(
        addToast({
          message,
          type: 'ERROR',
        })
      );

  const handleScanSuccess = ({ text, cancelled }) => {
    if (cancelled) {
      console.debug('Barcode scanning cancelled...');
      // onError('Luku keskeytetty');
      return;
    }

    if (!text) {
      console.debug('No result from barcode scanning...');
      onError('Ei tulosta');
      return;
    }

    onRead(text);
  };

  const handleScanFailure = error => {
    console.log(`Scanning failed: ${error}`);
    onError('QR- tai viivakoodin luku epäonnistui');
  };

  const openQRCodeReader = () => {
    if (window.cordova) {
      const options = {
        showTorchButton: true, // iOS and Android
        prompt: 'Aseta viivakoodi etsintäalueen sisälle', // Android
        resultDisplayDuration: 0,
        disableAnimations: true, // iOS
        disableSuccessBeep: false, // iOS,
        orientation: 'portrait',
        // TODO: should be faster if we define this
        // formats : "QR_CODE,PDF_417",
      };

      window.cordova.plugins.barcodeScanner.scan(
        handleScanSuccess,
        handleScanFailure,
        options
      );
    } else {
      console.error('BARCODE SCANNER NOT AVAILABLE!');
      onError('Viivakoodinlukijaan ei saatu yhteyttä');
    }
  };

  return openQRCodeReader;
};

export default useQRCodeReader;
